import { LOGIN_SUCCESS, LOGIN_FAIL } from "./types";
import Config  from "../components/Helpers/Config";
import Helpers from "../components/Helpers/Custom";
import setAuthTokenHeader from "../components/Helpers/setAuthTokenHeader";

import Axios from 'axios';

export const login = (dispatch) =>{
    let token = localStorage.getItem("jwt");
   console.log(token,"token")
    let auth = {}
    if(!Helpers.isEmpty(token)){
        setAuthTokenHeader(token)
        fetchUser(dispatch,token);
    }
}

export const fetchUser = (dispatch,token) =>{
    Axios.get(Config.api("api/user/info"))
        .then( (response) => {
            var data =  response.data;
            localStorage.setItem("userInfo",JSON.stringify(data));
          //  localStorage.setItem("prefNumber",data.)
            localStorage.setItem("amountDivision",data.amountDivision);
            localStorage.setItem("amountSymbol",data.amountSymbol);
            localStorage.setItem("prefRoundFraction",data.roundFraction);
            localStorage.setItem("prefRoundAmt",data.roundAmount);
            dispatch({
                type: 'LOGIN_SUCCESS',
                payload:{
                    isAuthenticated:true,
                    token:token,
                    userInfo:data
                }
            })
        })
        .catch((err) => {
           
        });
       
}